import { Component, OnInit, Input } from '@angular/core';
import { ImplementHistoryVM } from '../../equipment-details/equipment-details.model';

@Component({
  selector: 'app-implement-history',
  templateUrl: './implement-history.component.html',
  styleUrls: ['./implement-history.component.css']
})
export class ImplementHistoryComponent implements OnInit {
  @Input() historyDetails: ImplementHistoryVM[];

  historyDetails_ : ImplementHistoryVM[];
  constructor() { }

  ngOnInit() {
    this.historyDetails_= this.historyDetails.filter(x=>x.ActionDate != null);
  
    console.log("his", this.historyDetails)
  }

}
